<template>
    <div class="container-fluid pt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Report Comission</h5>
                </div>
            </div>
            <div class="card-body col-12">
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <!-- <h5>{{ params.divisi_name }}</h5> -->
                            <select v-model="params.divisi_id" class="form-select" style="max-width: 15rem;">
                                <option :value="null" disabled>Select Divisi</option>
                                <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">
                                    {{ option.name }}
                                </option>
                            </select>
                            <button class="btn btn-sm btn-primary" @click="data.value = {}; isform = true;"><i
                                    class="fa fa-solid fa-plus"></i>
                                Generade</button>
                        </div>
                        <DataTable :headers="headers" :items="salesComission" :loading="loading" :total="total"
                            :params="params" :selectable="true" :multiSelectable="false" @update:params="updateParams" @selection-change="handleSelectionChange">
                            <template #item.doc_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                                formatDateTime(item.CreatedAt) }}</template>
                            <template #item.document_start_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.document_start_date) }}</template>
                            <template #item.transaction_start_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.transaction_start_date) }}</template>
                            <template #item.transaction_end_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">{{
                                    formatDateTime(item.transaction_end_date) }}</template>
                            <template #item.actions="{ item }">
                                <button class="btn btn-sm btn-warning" :disabled="item.progress != 'DONE' || item.is_locked" @click="lockData(item)">
                                    <i class="fa fa-solid fa-lock"></i>
                                </button>&nbsp;
                                <button :disabled="item.progress != 'DONE'" class="btn btn-sm btn-primary" @click="downloadData(item)">
                                    <i class="fa fa-solid fa-download"></i>
                                </button>&nbsp;
                                <button class="btn btn-sm btn-info" :disabled="item.is_locked || (item.progress != 'DONE' && item.progress != 'READY TO CALCULATION')"  @click="recalculateData(item)">
                                    <i class="fa fa-solid fa-calculator"></i>
                                </button>&nbsp;
                                <button class="btn btn-sm btn-danger" :disabled="item.is_locked" @click="deleteData(item.ID)">
                                    <i class="fa fa-solid fa-trash"></i>
                                </button>
                            </template>
                        </DataTable>
                        <div class="card-body py-1" v-if="selectedReportId">
                            <h6>Comission Header</h6>
                            <div class="row g-2 align-items-end">
                                <div class="col-md-4">
                                    <label class="form-label">Search</label>
                                    <input v-model="headerSearchQuery" class="form-control" type="text" placeholder="Cari divisi team / tanggal..." />
                                </div>
                                <div class="col-md-8">
                                    <label class="form-label">Header</label>
                                    <select v-model="activeHeaderId" class="form-select" @change="onActiveHeaderChange">
                                        <option :value="null" disabled>Pilih header</option>
                                        <option v-for="header in filteredComissionHeaders" :key="header.ID" :value="header.ID">
                                            {{ header.divisi_team_name || header.divisi_name }} • {{ shortDate(header.comission_start_date) }} - {{ shortDate(header.comission_end_date) }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="mt-2" v-if="activeHeaderId">
                                <div v-if="detailsLoading[activeHeaderId]" class="py-3">Loading details...</div>
                                <div v-else class="datatable">
                                    <div class="table-responsive">
                                    <table class="table table-sm table-hover text-nowrap">
                                        <thead class="table-light">
                                            <tr>
                                                <th class="text-nowrap">No</th>
                                                <th class="text-nowrap">Periode</th>
                                                <th class="text-nowrap">Target1</th>
                                                <th class="text-nowrap">Amount1</th>
                                                <th class="text-nowrap">Target2</th>
                                                <th class="text-nowrap">Amount2</th>
                                                <th class="text-nowrap">Target3</th>
                                                <th class="text-nowrap">Amount3</th>
                                                <th class="text-nowrap">Target4</th>
                                                <th class="text-nowrap">Amount4</th>
                                                <th class="text-nowrap">Target5</th>
                                                <th class="text-nowrap">Amount5</th>
                                                <th class="text-nowrap">Total SO</th>
                                                <th class="text-nowrap">Total Closing</th>
                                                <th class="text-nowrap">Release Amount</th>
                                                <th class="text-nowrap">Total Order</th>
                                                <th class="text-nowrap">Total Release</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(detail, idx) in (detailsByHeader[activeHeaderId] || [])" :key="detail.ID || idx" :class="{ 'table-danger': (detail.total_so || 0) !== (detail.total_closing || 0), 'table-success': (detail.total_so || 0) === (detail.total_closing || 0) && detail.report_comission_id === selectedReportId }">
                                                <td>{{ idx + 1 }}</td>
                                                <td class="text-nowrap">
                                                    {{ shortDateTime(detail.comission_start) }}
                                                </td>
                                                <td>{{ separator(detail.target_1 || 0) }}</td>
                                                <td>{{ separator(detail.amount_1 || 0) }}</td>
                                                <td>{{ separator(detail.target_2 || 0) }}</td>
                                                <td>{{ separator(detail.amount_2 || 0) }}</td>
                                                <td>{{ separator(detail.target_3 || 0) }}</td>
                                                <td>{{ separator(detail.amount_3 || 0) }}</td>
                                                <td>{{ separator(detail.target_4 || 0) }}</td>
                                                <td>{{ separator(detail.amount_4 || 0) }}</td>
                                                <td>{{ separator(detail.target_5 || 0) }}</td>
                                                <td>{{ separator(detail.amount_5 || 0) }}</td>
                                                <td>{{ separator(detail.total_so || 0) }}</td>
                                                <td>{{ separator(detail.total_closing || 0) }}</td>
                                                <td>{{ separator(detail.release_amount || 0) }}</td>
                                                <td>{{ separator(detail.total_order || 0) }}</td>
                                                <td>{{ separator(detail.total_release || 0) }}</td>
                                            </tr>
                                            <tr v-if="(detailsByHeader[activeHeaderId] || []).length === 0">
                                                <td colspan="16" class="text-center text-muted">No details</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Form title="Report Comission Comission" v-if="isform" :data="data" @on-closed="isform = false; fetchSalesComission()" />
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent, computed } from 'vue'
const Form = defineAsyncComponent(() => import("./Form.vue"))
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { Modal } from 'bootstrap'
import * as sales from '@/api/services/SalesRequest'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const isform = ref(false)
const data = ref<any>({})
const divisiOptions = ref<{ ID: any }[]>([])
const selectedReportId = ref<number | null>(null)
const comissionHeaders = ref<any[]>([])
const activeHeaderId = ref<number | null>(null)
const detailsByHeader = ref<Record<number, any[]>>({})
const detailsLoading = ref<Record<number, boolean>>({})
const headerSearchQuery = ref<string>('')

// Computed property untuk mendapatkan header yang aktif
const activeHeader = computed(() => {
    if (!activeHeaderId.value) return null
    return comissionHeaders.value.find((h: any) => h.ID === activeHeaderId.value)
})

// {{ Define SalesOrder interface }}

const headers = [
    { text: '#Act', value: 'actions' },
    { text: 'Doc No', value: 'code' },
    { text: 'Doc Date', value: 'doc_date' },
    { text: 'Divisi', value: 'divisi_name' },
    { text: 'Name', value: 'name' },
    { text: 'Note', value: 'notes' },
    { text: 'Progress', value: 'progress' },
    { text: 'Transaction Start', value: 'transaction_start_date' },
    { text: 'Transaction End', value: 'transaction_end_date' },
]

// {{ Apply types to refs and reactive objects }}
const salesComission = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    divisi_id: '',
    divisi_name: ''
})
function update(item: any) {
    data.value = item
    isform.value = true
}
const fetchSalesComission = async () => {
    data.value = {}
    loading.value = true
    try {
        // Simulate API delay
        await sales.postRequest("/report-comission/list", params).then((response) => {
            salesComission.value = response.data;
            total.value = response.total
        });

    } catch (error) {
        toast.error('Failed to fetch sales closing')
    }
    loading.value = false
}

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchSalesComission()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

onMounted(() => {
    // Initialize division options
    divisiOptions.value = session.divisionOptions();
    console.log('Initialized divisiOptions:', divisiOptions.value);
    
    // Set current user's division as default filter
    const userDivision = session.divisionOptions().find((item) => item.name === session.getUser().divisi);
    if (userDivision) {
        params.divisi_id = userDivision.ID;
        // params.divisi_name = userDivision.name;
        console.log('Set user division filter:', userDivision);
    } else {
        console.warn('Could not find user division in options');
    }
    
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value);
    }
    
    // Initial data fetch
    fetchSalesComission();
})

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}

function formatDateForInput(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    // Format: YYYY-MM-DDThh:mm (format required for datetime-local input)
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
}

function totalSo(items: any[]) {
    return separator(items.reduce((total, item) => total + 1, 0));
}

function totalProduk(items: any[]) {
    return separator(items.reduce((total, item) => total + item.order.qty_total, 0));
}
function totalOmset(items: any[]) {
    return formatCurrency(items.reduce((total, item) => total + item.order.grand_total, 0));
}
function totalRelease(items: any[]) {
    return formatCurrency(items.reduce((total, item) => total + item.price, 0));
}

function separator(value: number) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatCurrency(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value);
}
function shortDate(dateStr: string) {
    if (!dateStr) return '-'
    const d = new Date(dateStr)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    return `${dd}/${mm}/${yyyy}`
}

function shortDateTime(dateStr: string) {
    if (!dateStr) return '-'
    const d = new Date(dateStr)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    const hh = String(d.getHours()).padStart(2, '0')
    const min = String(d.getMinutes()).padStart(2, '0')
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`
}
const handleSelectionChange = async (selectedIds: any[]) => {
    const id = selectedIds && selectedIds.length ? selectedIds[0] : null
    selectedReportId.value = id
    comissionHeaders.value = []
    detailsByHeader.value = {}
    activeHeaderId.value = null
    headerSearchQuery.value = ''
    if (!id) return
    await fetchHeaders()
}

const filteredComissionHeaders = computed(() => {
    const q = headerSearchQuery.value.toLowerCase().trim()
    if (!q) return comissionHeaders.value
    return comissionHeaders.value.filter((h: any) => {
        const label = `${h.divisi_team_name || ''} ${h.divisi_name || ''} ${h.comission_start_date || ''} ${h.comission_end_date || ''}`.toLowerCase()
        return label.includes(q)
    })
})

const onActiveHeaderChange = async () => {
    if (!activeHeaderId.value) return
    const header = comissionHeaders.value.find((h: any) => h.ID === activeHeaderId.value)
    if (!header) return
    await selectHeader(header)
}

const fetchHeaders = async () => {
    if (!selectedReportId.value) return
    try {
        const resp = await sales.postRequest('/comission/list-by-report', { report_comission_id: selectedReportId.value })
        if (resp.status === 200) {
            comissionHeaders.value = resp.data || []
            if (comissionHeaders.value.length > 0) {
                activeHeaderId.value = comissionHeaders.value[0].ID
                await selectHeader(comissionHeaders.value[0])
            }
        } else {
            comissionHeaders.value = []
        }
    } catch (e) {
        comissionHeaders.value = []
    }
}
const selectHeader = async (header: any) => {
    if (!header || !header.ID) return
    activeHeaderId.value = header.ID
    if (!detailsByHeader.value[header.ID]) {
        detailsLoading.value[header.ID] = true
        try {
            const resp = await sales.postRequest('/comission/detail/list', { comission_id: header.ID })
            if (resp.status === 200) {
                detailsByHeader.value[header.ID] = resp.data || []
            } else {
                detailsByHeader.value[header.ID] = []
            }
        } catch (e) {
            detailsByHeader.value[header.ID] = []
        } finally {
            detailsLoading.value[header.ID] = false
        }
    }
}
const deleteData = async (id: number) => {
    if (!confirm('Are you sure you want to delete this Report Comission?')) return

    loading.value = true
    try {
        await sales.postRequest("/report-comission/delete", { ID: id }).then((resp) => {
            if (resp.status === 200) {
                toast.success('Report Comission deleted successfully');
                fetchSalesComission();
            } else {
                toast.error('Failed to delete Report Comission');
            }
        })
    } catch (error: any) {
        toast.error(error.message || 'Failed to delete Report Comission');
    } finally {
        loading.value = false
    }
}

const lockData = async (item: any) => {
    if (!item || !item.ID) return
    if (!confirm('Apakah data akan di lock?')) return

    loading.value = true
    try {
        const resp = await sales.postRequest("/report-comission/lock", { ID: item.ID })
        if (resp.status === 200) {
            item.is_locked = true
            toast.success('Data berhasil di lock')
            fetchSalesComission()
        } else {
            toast.error('Gagal lock data')
        }
    } catch (error: any) {
        toast.error(error.message || 'Gagal lock data')
    } finally {
        loading.value = false
    }
}

const cloneData = (item: any) => {
    console.log('Original item to clone:', item)
    console.log('Available divisiOptions:', divisiOptions.value)
    
    // Create a deep copy of the item without the ID and other specific fields
    const clonedItem = JSON.parse(JSON.stringify(item))
    delete clonedItem.ID // Remove ID so it will be treated as a new record
    delete clonedItem.code // Remove code so it will be generated automatically
    delete clonedItem.CreatedAt // Remove timestamps
    delete clonedItem.UpdatedAt
    delete clonedItem.deleted_at
    delete clonedItem.progress // Remove progress status
    
    // Reset name to indicate it's a clone
    if (clonedItem.name) {
        clonedItem.name = clonedItem.name
    }
    
    // Ensure dates are properly formatted for the form (datetime-local format)
    if (clonedItem.document_start_date) {
        clonedItem.document_start_date = formatDateForInput(clonedItem.document_start_date)
    }
    if (clonedItem.document_end_date) {
        clonedItem.document_end_date = formatDateForInput(clonedItem.document_end_date)
    }
    if (clonedItem.transaction_start_date) {
        clonedItem.transaction_start_date = formatDateForInput(clonedItem.transaction_start_date)
    }
    if (clonedItem.transaction_end_date) {
        clonedItem.transaction_end_date = formatDateForInput(clonedItem.transaction_end_date)
    }
    
    // Ensure divisi is properly set with complete object structure
    if (clonedItem.divisi_id) {
        // Try to find the divisi by ID from available options
        const foundDivisi = divisiOptions.value.find(d => d.ID === clonedItem.divisi_id)
        console.log('Found divisi by ID:', foundDivisi)
        
        if (foundDivisi) {
            clonedItem.divisi = foundDivisi
            clonedItem.divisi_name = foundDivisi.name
            clonedItem.divisi_id = foundDivisi.ID
        } else {
            console.warn('Could not find divisi with ID:', clonedItem.divisi_id)
            // Reset divisi data if not found
            clonedItem.divisi = null
            clonedItem.divisi_name = null
            clonedItem.divisi_id = null
        }
    } else if (clonedItem.divisi_name) {
        // If we have a divisi_name but no divisi object, try to find it by name
        const foundDivisi = divisiOptions.value.find(d => d.name === clonedItem.divisi_name)
        console.log('Found divisi by name:', foundDivisi)
        
        if (foundDivisi) {
            clonedItem.divisi = foundDivisi
            clonedItem.divisi_id = foundDivisi.ID
            clonedItem.divisi_name = foundDivisi.name
        } else {
            console.warn('Could not find divisi with name:', clonedItem.divisi_name)
            // Reset divisi data if not found
            clonedItem.divisi = null
            clonedItem.divisi_name = null
            clonedItem.divisi_id = null
        }
    }
    
    // Ensure notes is reset or set properly
    if (!clonedItem.notes) {
        clonedItem.notes = null
    }
    
    console.log('Cloned item after processing:', clonedItem)
    
    // Set the data and open the form
    data.value = clonedItem
    isform.value = true
}

const recalculateData = async (item: any) => {
    if (!confirm('Are you sure you want to recalculate this Report Comission?')) return

    loading.value = true
    try {
        // Show info toast that recalculation is starting
        toast.info('Recalculation started for Report Comission: ' + item.code, {
            autoClose: 3000,
            position: 'top-right'
        });
        
        // Prepare data for recalculation - send the complete item data
        const recalculateData = {
            ID: item.ID,
            code: item.code,
            divisi_id: item.divisi_id,
            divisi_name: item.divisi_name,
            divisi: item.divisi,
            document_type: item.document_type,
            transaction_start_date: item.transaction_start_date,
            transaction_end_date: item.transaction_end_date,
            document_end_date: item.document_end_date,
            name: item.name,
            notes: item.notes,
            status: item.status,
            progress: item.progress,
            created_by: item.created_by
        };
        
        await sales.postRequest("/report-comission/recalculate", recalculateData).then(async (resp) => {
            if (resp.status === 200) {
                toast.success('Recalculation queued for Report Comission: ' + item.code);
            } else {
                toast.error('Failed to recalculate Report Comission: ' + item.code);
            }
        });

    } catch (error: any) {
        toast.error(error.message || 'Failed to recalculate Report Comission: ' + item.code);
    } finally {
        loading.value = false
    }
}

const downloadData = async (data: any) => {
    if (!confirm('Are you sure you want to download this Report Comission?')) return

    loading.value = true
    try {
        const prms = { id: data.ID }
        try {
            const response = await sales.postDownload("/report-comission/download-excel", prms);
            
            // Check if response is JSON (error message) despite arraybuffer type
            if (response && response.byteLength < 1000) {
                 try {
                    const text = new TextDecoder().decode(response);
                    const json = JSON.parse(text);
                    if (json && (json.message || json.error)) {
                        toast.error(json.message || json.error || 'Failed to download file');
                        return;
                    }
                 } catch (e) {
                     // Not JSON, proceed as file
                 }
            }

            // Create blob from response data
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', (data.code || 'report') + '-' + (data.name || 'comission') + '.xlsx');
            // Trigger download
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            toast.error('Failed to download file. Please try again.');
        }

    } catch (error) {
        toast.error('Failed to fetch download')
    }
    loading.value = false
}

</script>
